module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAVCAYAAABc6S4mAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEHSURBVHgBvZTrEYIwEIQ3Dv+lhJRAB1KCHUgHjh3YCZSAFYAdaAViBdAB3kEYMbwSHn4zAVzP3N1eRGCAsix9uvmYJqOVCiEymEKby9KOZGiv3YAewA4flgn6iITC4jdw+EItnlUVrtKlFpfRemqf3VY8NJsKWpdqLvTFccLfGD0YzCnnOLbIwzg55lF15xgE+lRNSPcbtRyr6kO07BnDJIFEfaretBq7AhhikqDhRJUfYFj5nAQS3dNlneCB+ohJfDdbolUDuzbnagvt559MWsffJRqjW5RQILfpraR13kXs4x21l2to/5+BVI/7NTRGn8GrVcwaWtVBgQ3hDiL1bPUKMCDlywf9i1/BDdKo1wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hospital-icon-white.png
// module id = bIbl
// module chunks = 1